import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tool-arrow-right",
  "use": "tool-arrow-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tool-arrow-right\">\r\n<path d=\"M5.94799 4.867C5.64699 4.558 5.64699 4.057 5.93799 3.737C6.22099 3.436 6.72199 3.42 7.00099 3.737L10.501 7.435C10.792 7.745 10.792 8.255 10.501 8.565L7.00099 12.263C6.70999 12.583 6.23899 12.583 5.93799 12.263C5.64699 11.954 5.64699 11.442 5.94799 11.133L8.90599 8L5.94799 4.867Z\" fill=\"black\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol